// src/lib/hooks/useIsomorphicLayoutEffect.ts
'use client'

import { useEffect, useLayoutEffect } from 'react'

/**
 * `useLayoutEffect` on the client, `useEffect` on the server.
 *
 * `useLayoutEffect` is the right tool for synchronous, pre-paint work — e.g. the
 * Cache Components `<Activity>` cleanups that must run BEFORE a route is hidden
 * (pausing media, closing transient UI) to avoid a flash of stale state. But it
 * logs React's "useLayoutEffect does nothing on the server" warning when a
 * client component is server-prerendered (which every route is). Swapping to
 * `useEffect` on the server (where the effect is a no-op anyway) silences the
 * warning with zero behavioral change on the client.
 */
export const useIsomorphicLayoutEffect =
  typeof document !== 'undefined' ? useLayoutEffect : useEffect
